import { store } from '@betacrew/jars-flux';
import { all, call, put,select, takeLatest } from 'redux-saga/effects';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice'; 
import { PAGE_STATE } from '../../constants/constants';
import { componentKey, setLoadingState, setStatus } from './CheckStatusSlice';
import ShortcutDataService from '../../../../services/ShortcutsDataService';

export const { checkStatus } = {
    checkStatus: (payload) => {
        return {
            type: "CHECKSTATUS/CHECK_STATUS",
            payload: payload
        }
    },
}

function* checkStatusAsync(action) {

    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Checking Status..." }))
        const response = yield ShortcutDataService.checkStatus(action.payload);

        if (response?.data.Status === 1) {
            yield put(setStatus(response.data.Message))
        } else {
            yield put(addNotifications({ 
                heading: "Error Checking Status", 
                message: response?.data?.Message 
            }));
        }

    } catch (error) {
        yield put(addNotifications({ heading: "Error Checking Status", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }

}

function* rootSaga() {
    yield all([
        takeLatest(checkStatus().type, checkStatusAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);